import axios from 'axios'
import { API_URLS_CHATWOOT } from '@/constants'

const base = () => API_URLS_CHATWOOT.baseUrl

/**
 * Arma los params del listado a partir de los filtros activos (omite vacíos).
 */
const buildParams = (state, { page, perPage }) => {
  const params = {
    page: page ?? state.page,
    per_page: perPage ?? state.perPage
  }
  const f = state.filtros

  if (f.search) params.search = f.search
  if (f.canal) params.canal = f.canal
  if (f.estado) params.estado = f.estado
  if (f.match_estado) params.match_estado = f.match_estado
  if (f.con_cliente !== null && f.con_cliente !== '') params.con_cliente = f.con_cliente
  if (f.id_cliente) params.id_cliente = f.id_cliente

  return params
}

export default {
  getConversaciones({ commit, state }, { page, perPage } = {}) {
    commit('SET_LOADING', true)
    if (page) commit('SET_PAGE', page)
    if (perPage) commit('SET_PER_PAGE', perPage)

    const params = buildParams(state, { page, perPage })

    return axios
      .get(base() + API_URLS_CHATWOOT.conversaciones, { params })
      .then((res) => {
        commit('SET_CONVERSACIONES', res.data)

        return res.data
      })
      .finally(() => commit('SET_LOADING', false))
  },

  getConversacion({ commit }, id) {
    commit('SET_LOADING_DETALLE', true)
    commit('SET_DETALLE', null)

    return axios
      .get(base() + API_URLS_CHATWOOT.conversacion(id))
      .then((res) => {
        commit('SET_DETALLE', res.data)

        return res.data
      })
      .finally(() => commit('SET_LOADING_DETALLE', false))
  },

  setFiltro({ commit }, payload) {
    commit('SET_FILTRO', payload)
  },

  limpiarFiltros({ commit }) {
    commit('RESET_FILTROS')
  },

  // Sugerencias de cliente basadas en el teléfono de la conversación
  getSugerenciasCliente(_, id) {
    return axios
      .get(base() + API_URLS_CHATWOOT.sugerenciasCliente(id))
      .then((res) => res.data)
  },

  // Búsqueda libre de clientes para el selector
  buscarClientes(_, q) {
    return axios
      .get(base() + API_URLS_CHATWOOT.buscarClientes, { params: { q } })
      .then((res) => res.data)
  },

  // Asocia un cliente; recarga el detalle completo (mensajes/agentes incluidos)
  asociarCliente({ dispatch }, { id, idCliente }) {
    return axios
      .post(base() + API_URLS_CHATWOOT.asociarCliente(id), { id_cliente: idCliente })
      .then((res) => dispatch('getConversacion', id).then(() => res.data))
  },

  // Quita la asociación de cliente; recarga el detalle completo
  desasociarCliente({ dispatch }, id) {
    return axios
      .delete(base() + API_URLS_CHATWOOT.asociarCliente(id))
      .then((res) => dispatch('getConversacion', id).then(() => res.data))
  },

  // Búsqueda libre de usuarios del portal (selector de agente)
  buscarUsuarios(_, q) {
    return axios
      .get(base() + API_URLS_CHATWOOT.buscarUsuarios, { params: { q } })
      .then((res) => res.data)
  },

  // Asigna manualmente un usuario del portal a un agente; recarga el detalle
  asignarUsuarioAgente({ dispatch }, { id, agenteId, usuarioId }) {
    return axios
      .post(base() + API_URLS_CHATWOOT.usuarioAgente(id, agenteId), { usuario_id: usuarioId })
      .then((res) => dispatch('getConversacion', id).then(() => res.data))
  },

  // Quita la asignación manual de un agente; recarga el detalle
  quitarUsuarioAgente({ dispatch }, { id, agenteId }) {
    return axios
      .delete(base() + API_URLS_CHATWOOT.usuarioAgente(id, agenteId))
      .then((res) => dispatch('getConversacion', id).then(() => res.data))
  },

  // Envía un mensaje (privado=true => nota interna) hacia la conversación en
  // Chatwoot; luego recarga el detalle para reflejar el nuevo mensaje.
  enviarMensaje({ dispatch }, { id, contenido, privado = false }) {
    return axios
      .post(base() + API_URLS_CHATWOOT.enviarMensaje(id), { contenido, privado })
      .then((res) => dispatch('getConversacion', id).then(() => res.data))
  },

  // Mantenedor: obtiene la configuración del módulo (switch del menú, horario y
  // mensajes fuera de horario por canal).
  getConfig() {
    return axios
      .get(base() + API_URLS_CHATWOOT.config)
      .then((res) => res.data)
  },

  // Mantenedor: guarda la configuración del módulo.
  updateConfig(_, payload) {
    return axios
      .put(base() + API_URLS_CHATWOOT.config, payload)
      .then((res) => res.data)
  },

  // Próximos feriados de Chile (para el modal "Ver feriados").
  getFeriados() {
    return axios
      .get(base() + API_URLS_CHATWOOT.feriados)
      .then((res) => res.data)
  }
}
